import { BigInteger, IMonitorInfo, IAndroidSystemInfo, IIOSSystemInfo, IMainSystemInfo, IUniversalWindowsSystemInfo, IWindowsSystemInfo, ISystemInfo, bigIntZero } from 'app/modules/remote-control-ng/definitions';
import { BehaviorSubject } from "rxjs";

export class MainSystemInfo implements IMainSystemInfo {
    sysInfoSize: number = 0;

    // System Info
    osType: number = 0;
    cpuType: number = 0;
    cpuSize: number = 0;
    cpuCount: number = 0;
    cpuSpeed: number = 0;
    osVersion: number = 0;
    osBuild: number = 0;
    agentVersion: number = 0;

    // Memory Info
    totalMemory: BigInteger;
    freeMemory: BigInteger;
    totalVirtualMemory: BigInteger = bigIntZero;
    freeVirtualMemory: BigInteger = bigIntZero;

    // Storage Info
    totalStorage: BigInteger = bigIntZero;
    freeStorage: BigInteger = bigIntZero;

    // Display Info
    scrWidth: number = 0;
    scrHeight: number = 0;
    bitsPerPixel: number = 0;

    // Network
    connectionType: number = 0;
    monitorsInfo?: IMonitorInfo[];
};

export class WindowsSystemInfo implements IWindowsSystemInfo {
    memoryLoad: number = 0; // DWORD
    pageSize: number = 0; // DWORD
    minAppAddress: BigInteger; // QWORD
    maxAppAddress: BigInteger; // QWORD
    monitors: number = 0; // DWORD
    versionInfo: string = ""; // WCHAR[80]
    processorName: string = ""; // WCHAR[80]

    // Battery
    batteryLifetime: number = 0; // DWORD
    batteryFullLifeTime: number = 0; // DWORD
    batteryFlag: number = 0; // BYTE
    batteryLifePercent: number = 0; // BYTE
    batteryReserved: number[] = [0, 0]; // BYTE[2]

    acLineStatus: number = 0; // BYTE
    reserved: number[] = [0, 0, 0]; // BYTE[3]
    monitorsInfo?: IMonitorInfo[] = [];
};

export class WindowsCeSystemInfo {
    // Battery
    backupBatteryLifetime: number = 0; // DWORD
    backupBatteryFullLifeTime: number = 0; // DWORD
    backupBatteryFlag: number = 0; // BYTE
    backupBatteryLifePercent: number = 0; // BYTE
    backupBatteryReserved: number = 0; // BYTE[2]
};

export class UniversalWindowsSystemInfo {
    // Battery
    batteryFlag: number = 0; // BYTE
    batteryLifePercent: number = 0; // BYTE
};

export class MonitorInfo implements IMonitorInfo {
    name: string = "";
    id: number = 0; // DWORD
    width: number = 0; // DWORD
    height: number = 0; // DWORD,
    rotation$: BehaviorSubject<number> = new BehaviorSubject(null);
    rotation: number = 0;
    top: number = 0;
    left: number = 0;
};
export class AndroidSystemInfo implements IAndroidSystemInfo {
    batteryStatus: number = 0; // DWORD
    batteryLevel: number = 0; // DWORD
    batteryVoltage: number = 0; // DWORD
    batteryTemperature: number = 0; // DWORD

    // Multiscreen - Monitor Info
    monitorNumber: number = 0;  // DWORD
    monitorList: IMonitorInfo[] = []; // List of MonitorInfo
};

export class IOSSystemInfo implements IIOSSystemInfo {
    batteryStatus: number = 0; // DWORD
    batteryLevel: number = 0; // DWORD
    deviceModel: string = ""; // WCHAR[20]
    deviceName: string = ""; // WCHAR[40]
};

export class SystemInfo implements ISystemInfo{
    main: IMainSystemInfo;
    platformSpecific: IAndroidSystemInfo | IWindowsSystemInfo | IUniversalWindowsSystemInfo | IIOSSystemInfo;

    constructor(mainInfo: IMainSystemInfo, specificInfo: IAndroidSystemInfo | IWindowsSystemInfo | IUniversalWindowsSystemInfo | IIOSSystemInfo) {
        this.main = mainInfo;
        this.platformSpecific = specificInfo;
    }
}
